export default "__VITE_ASSET__DNa3C8EL__"